import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { CommonLayout } from "../components/CommonLayout";
import { Practices } from "components/Practices";
import { RecipientUsers } from "components/RecipientUsers";
import { Buttons } from "components/Buttons";
import { Referrals } from "components/Referrals";
import { ReferralDetails } from "components/ReferralDetails";
import { Profile } from "components/Profile";
import { ReactComponent as ReferralsIcon } from "images/referrals-icon.svg";
import { ReactComponent as PracticesIcon } from "images/practices-icon.svg";
import { ReactComponent as OriginatorsIcon } from "images/originators-icon.svg";
import { ReactComponent as ButtonsIcon } from "images/buttons-icon.svg";
import { ReactComponent as SpecialistsIcon } from "images/specialists-icon.svg";
import { ReactComponent as ReferralFormIcon } from "images/embedded-form-icon.svg";
import { MyOrganizationDetails } from "components/MyOrganizationDetails";
import { Billing } from "components/Billing";
import { InvoiceDetails } from "components/InvoiceDetails";
import { Regions } from "components/Regions";
import { MyButtons } from "components/MyButtons";
import { UnsubscribePage } from "components/UnsubscribePage";
import { PracticeDetails } from "components/PracticeDetails";
import { Senders } from "components/Senders";
import { PaymentMethods } from "components/PaymentMethods";
import { Payments } from "components/Payments";
import { Locations } from "components/Locations";
import { RecipientAnalytics } from "components/RecipientAnalytics";
import { ReferralFormCreation } from "components/ReferralFormCreation";
import { SimplifiedSignUpSender } from "components/SimplifiedSignUpSender";
import { guideSteps } from "hooks/useOnboarding";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <CommonLayout
        menu={[
          {
            label: "Referral Stream",
            path: "/",
            Icon: ReferralsIcon,
            // guideClass: guideSteps.PROFILE,
          },
          { label: "Practices", path: "/practices", Icon: PracticesIcon, guideClass: guideSteps.PRACTICES, },
          {
            label: "Senders",
            path: "/senders",
            Icon: OriginatorsIcon,
            guideClass: guideSteps.SENDERS,
          },
          {
            label: "Buttons",
            path: "/button_locations",
            Icon: ButtonsIcon,
            guideClass: guideSteps.BUTTONS,
          },
          {
            label: "Analytics",
            path: "/analytics",
            Icon: ReferralsIcon,
            guideClass: guideSteps.ANALYTICS,
          },
          {
            label: "My Organization",
            Icon: SpecialistsIcon,
            subItems: [
              { label: "Organization Profile", path: "/my_organization_details", guideClass: guideSteps.ORGANIZATION_PROFILE },              
              { label: "Users", path: "/users", guideClass: guideSteps.USERS },
              { label: "Locations", path: "/locations" },
              { label: "Regions", path: "/regions" },
              {
                label: "Billing",
                path: "/billing",
              },
              {
                label: "Payments",
                path: "/payments",
              },
              {
                label: "Payment Method",
                path: "/payment_method",
                guideClass: guideSteps.PAYMENT,
              },
            ],
          },
          {
            label: "Referral Form",
            path: "/referral_form",
            Icon: ReferralFormIcon,
          },
        ]}
      />
    ),
    children: [
      {
        path: "/",
        element: <Referrals />,
      },
      {
        path: "/analytics",
        element: <RecipientAnalytics />,
      },
      {
        path: "/button_locations",
        element: <Buttons />,
      },
      {
        path: "/regions",
        element: <Regions />,
      },
      {
        path: "/my_button_dashboard",
        element: <MyButtons />,
      },
      {
        path: "/unsubscribe/:token",
        element: <UnsubscribePage />,
      },
      {
        path: "/practices",
        element: <Practices />,
      },
      {
        path: "/practice/:id",
        element: <PracticeDetails />,
      },
      {
        path: "/senders",
        element: <Senders />,
      },
      {
        path: "/users",
        element: <RecipientUsers />,
      },
      {
        path: "/locations",
        element: <Locations />,
      },
      {
        path: "/my_organization_details",
        element: <MyOrganizationDetails />,
      },
      {
        path: "/referral/:id",
        element: <ReferralDetails />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/referral_form",
        element: <ReferralFormCreation />,
      },
      {
        path: "/billing",
        element: <Billing />,
      },
      {
        path: "/payments",
        element: <Payments />,
      },
      {
        path: "/invoice/:id",
        element: <InvoiceDetails />,
      },
      {
        path: "/payment_method",
        element: <PaymentMethods />,
      },
      {
        path: "/sign_up/sender",
        element: <SimplifiedSignUpSender />,
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);

export const Admin = () => <RouterProvider router={router} />;
